import go from 'gojs';

// Define types for options and callbacks
export interface NodeTemplateOptions {
    readonly: boolean;
    direction: 'IN' | 'OUT';
}

export interface CablesNodeTemplateCallbacks {
    onDeleteCableClick: (capId: string) => void;
}

export interface PinsNodeTemplateCallbacks {
    onDeletePinClick: (pinId: string) => void;
    onPinClick?: (pinId: string) => void;
}

export function createConnectionCablesNodeTemplate(options: NodeTemplateOptions, callbacks: CablesNodeTemplateCallbacks): go.Node {
    const $ = go.GraphObject.make;

    const isIn = options.direction === 'IN';

    return $(
        go.Node,
        go.Panel.Horizontal,
        {
            selectable: true,
            movable: true,
        },
        $(
            go.Panel,
            go.Panel.Auto,
            {
                margin: 0,
            },
            $(go.Shape, 'Rectangle', {
                fill: '#f5f5f5',
                stroke: '#cccccc',
                strokeWidth: 1,
                parameter1: 15,
                width: 298,
            }),
            $(
                go.Panel,
                go.Panel.Vertical,
                {},
                $(
                    go.Panel,
                    go.Panel.Horizontal,
                    {
                        margin: 0,
                        // width: 120,
                    },

                    $(
                        go.Panel,
                        go.Panel.Auto,
                        {
                            margin: new go.Margin(0, 7, 0, 1),
                        },
                        $(go.Shape, 'Rectangle', {
                            fill: '#f5f5f5',
                            stroke: '#000',
                            strokeWidth: 1,
                            parameter1: 15,
                        }),
                        $(go.TextBlock, {
                            margin: new go.Margin(0, 0, 0, 0),
                            text: 'Out Cap',
                            stroke: '#1976d2',
                        })
                    ),
                    $(go.TextBlock, {margin: new go.Margin(0, 10, 0, 0)}, new go.Binding('text', 'text')),
                    $(
                        go.Shape,
                        'Circle',
                        {
                            desiredSize: new go.Size(14, 14),
                            stroke: 'black',
                            fill: 'white',
                            strokeWidth: 2,
                            cursor: 'pointer',
                            margin: new go.Margin(0, 0, 0, 0),
                        },
                        new go.Binding('fill', 'isActive', function (s) {
                            return s ? 'black' : 'white';
                        })
                    ),
                    $(go.Picture, {
                        source: '/icons/delete-empty-red.svg',
                        width: 20,
                        height: 20,
                        cursor: 'pointer',
                        margin: new go.Margin(0, 0, 0, 10),
                        imageAlignment: go.Spot.Center,
                        imageStretch: go.GraphObject.Uniform,
                        scale: 1,
                        click: (e: any, obj: any) => {
                            const node = obj.part;
                            const cableId = node?.data?.key;
                            if (cableId && callbacks.onDeleteCableClick) {
                                callbacks.onDeleteCableClick(cableId);
                            }
                        },
                    }),
                    $(
                        go.Panel,
                        go.Panel.Auto,
                        {
                            margin: new go.Margin(0, 0, 0, 7),
                        },
                        $(go.Shape, 'Rectangle', {
                            fill: '#f5f5f5',
                            stroke: '#000',
                            strokeWidth: 1,
                            parameter1: 15,
                        }),
                        $(go.TextBlock, {
                            margin: new go.Margin(0, 0, 0, 0),
                            text: 'In Cap',
                            stroke: '#1976d2',
                        })
                    )
                ),
                $(
                    go.Panel,
                    go.Panel.Horizontal,
                    {
                        margin: new go.Margin(10, 0, 10, 0),
                        width: NaN,
                    },

                    $(
                        go.Panel,
                        go.Panel.Vertical,
                        {
                            margin: 0,
                            width: NaN,
                        },
                        // Add border to each Picture by wrapping in a Panel with a Shape as border
                        ...Array.from({length: 1}).map((_, idx) =>
                            $(
                                go.Panel,
                                go.Panel.Spot,
                                {},
                                $(go.Shape, 'Rectangle', {
                                    desiredSize: new go.Size(24, 24),
                                    stroke: '#1976d2',
                                    strokeWidth: 1,
                                    fill: 'transparent',
                                    geometryString: idx === 0 ? 'M0,0 L0,24 L24,24 L24,0 Z' : 'M0,0 L0,110 L200,110 L200,0',
                                }),
                                $(go.Picture, {
                                    source: '/icons/link-variant.svg',
                                    width: 20,
                                    height: 20,
                                    cursor: 'pointer',
                                    margin: new go.Margin(0, 0, 0, 0),
                                    imageAlignment: go.Spot.Center,
                                    imageStretch: go.GraphObject.Uniform,
                                    scale: 1,
                                    fromLinkable: false,
                                    toLinkable: true,
                                    toLinkableDuplicates: false,
                                    toMaxLinks: 1,
                                    // fromSpot: go.Spot.Right,
                                    portId: `cable-left-side_${idx}`,
                                })
                            )
                        )
                    ),
                    $(
                        go.Panel,
                        go.Panel.Vertical,
                        {
                            margin: 0,
                            width: 246,
                            alignment: go.Spot.Center,
                        },
                        $(go.Panel, go.Panel.Vertical, {margin: 0})
                    ),
                    $(
                        go.Panel,
                        go.Panel.Vertical,
                        {
                            margin: 0,
                            width: NaN,
                        },
                        // Add border to each Picture by wrapping in a Panel with a Shape as border
                        ...Array.from({length: 1}).map((_, idx) =>
                            $(
                                go.Panel,
                                go.Panel.Spot,
                                {},
                                $(go.Shape, 'Rectangle', {
                                    desiredSize: new go.Size(24, 24),
                                    stroke: '#1976d2',
                                    strokeWidth: 1,
                                    fill: 'transparent',
                                    geometryString:
                                        idx === 0
                                            ? // All sides for first index
                                              'M0,0 L0,24 L24,24 L24,0 Z'
                                            : // Only left, right, bottom for others
                                              'M0,0 L0,110 L200,110 L200,0',
                                }),
                                $(go.Picture, {
                                    source: '/icons/link-variant.svg',
                                    width: 20,
                                    height: 20,
                                    cursor: 'pointer',
                                    margin: new go.Margin(0, 0, 0, 0),
                                    imageAlignment: go.Spot.Center,
                                    imageStretch: go.GraphObject.Uniform,
                                    scale: 1,
                                    fromLinkable: true,
                                    toLinkable: false,
                                    toLinkableDuplicates: false,
                                    toMaxLinks: 1,
                                    fromSpot: go.Spot.Right,
                                    portId: `cable-right-side_${idx}`,
                                })
                            )
                        )
                    )
                )
            )
        )
    );
}

export function createConnectionPinsNodeTemplate(options: NodeTemplateOptions, callbacks: PinsNodeTemplateCallbacks): go.Node {
    const $ = go.GraphObject.make;

    const isIn = options.direction === 'IN';

    return $(
        go.Node,
        go.Panel.Horizontal,
        {
            selectable: false,
            movable: false,
        },
        $(
            go.Panel,
            go.Panel.Auto,
            {
                margin: 1,
            },
            $(go.Shape, 'Rectangle', {
                fill: '#f5f5f5',
                stroke: '#cccccc',
                strokeWidth: 1,
                parameter1: 15,
                width: 160,
                height: 130,
            }),
            $(
                go.Panel,
                go.Panel.Horizontal,
                {
                    margin: 1,
                    width: NaN,
                },
                ...(!isIn
                    ? [
                          $(
                              go.Panel,
                              go.Panel.Vertical,
                              {
                                  margin: 0,
                                  width: 132,
                              },
                              $(
                                  go.TextBlock,
                                  {
                                      margin: 0,
                                      cursor: 'pointer',
                                      click: (e: any, obj: any) => {
                                          const node = obj.part;
                                          const pinId = node?.data?.key;
                                          if (pinId && callbacks.onPinClick) {
                                              callbacks.onPinClick(pinId);
                                          }
                                      },
                                  },
                                  new go.Binding('text', 'text')
                              ),
                              $(
                                  go.Shape,
                                  'Circle',
                                  {
                                      desiredSize: new go.Size(14, 14),
                                      stroke: 'black',
                                      fill: 'white',
                                      strokeWidth: 2,
                                      cursor: 'pointer',
                                      margin: new go.Margin(0, 0, 0, 0),
                                  },
                                  new go.Binding('fill', 'isActive', function (s) {
                                      return s ? 'black' : 'white';
                                  })
                              )
                          ),
                      ]
                    : []),
                $(
                    go.Panel,
                    go.Panel.Vertical,
                    {
                        margin: 0,
                        width: NaN,
                    },
                    // Add border to each Picture by wrapping in a Panel with a Shape as border
                    ...Array.from({length: 5}).map((_, idx) =>
                        $(
                            go.Panel,
                            go.Panel.Spot,
                            {},
                            $(go.Shape, 'Rectangle', {
                                desiredSize: new go.Size(24, 24),
                                stroke: '#1976d2',
                                strokeWidth: 1,
                                fill: 'transparent',
                                geometryString:
                                    idx === 0
                                        ? // All sides for first index
                                          'M0,0 L0,24 L24,24 L24,0 Z'
                                        : // Only left, right, bottom for others
                                          'M0,0 L0,110 L200,110 L200,0',
                            }),
                            $(go.Picture, {
                                source: '/icons/link-variant.svg',
                                width: 20,
                                height: 20,
                                cursor: 'pointer',
                                margin: new go.Margin(0, 0, 0, 0),
                                imageAlignment: go.Spot.Center,
                                imageStretch: go.GraphObject.Uniform,
                                scale: 1,
                                fromLinkable: !isIn,
                                toLinkable: isIn,
                                toLinkableDuplicates: false,
                                toMaxLinks: 1,
                                fromSpot: isIn ? go.Spot.Left : go.Spot.Right,
                                portId: isIn ? `in-pin-left-side_${idx}` : `out-pin-right-side_${idx}`,
                            })
                        )
                    )
                ),
                ...(isIn
                    ? [
                          $(
                              go.Panel,
                              go.Panel.Vertical,
                              {
                                  margin: 0,
                                  width: 132,
                              },
                              $(
                                  go.TextBlock,
                                  {
                                      margin: 1,
                                  },
                                  new go.Binding('text', 'text')
                              ),
                              $(
                                  go.Shape,
                                  'Circle',
                                  {
                                      desiredSize: new go.Size(14, 14),
                                      stroke: 'black',
                                      fill: 'white',
                                      strokeWidth: 2,
                                      cursor: 'pointer',
                                      margin: new go.Margin(0, 0, 0, 0),
                                  },
                                  new go.Binding('fill', 'isActive', function (s) {
                                      return s ? 'black' : 'white';
                                  })
                              )
                          ),
                      ]
                    : [])
            )
        )
    );
}

export function createConnectionCoreNodeTemplate(options: NodeTemplateOptions, callbacks: PinsNodeTemplateCallbacks): go.Node {
    const $ = go.GraphObject.make;

    const isIn = options.direction === 'IN';

    return $(
        go.Node,
        go.Panel.Horizontal,
        {
            selectable: true,
            movable: true,
        },
        $(
            go.Panel,
            go.Panel.Auto,
            {
                margin: 0,
            },
            // $(go.Shape, 'RoundedRectangle', {
            //     fill: '#aaaaaa',
            //     stroke: '#444444',
            //     strokeWidth: 2,
            //     parameter1: 15,
            //     width: 200,
            //     height: 10,
            // }),

            $(
                go.Panel,
                go.Panel.Horizontal,
                {
                    margin: 0,
                },
                $(go.Picture, {
                    source: '/icons/link-variant.svg',
                    width: 20,
                    height: 20,
                    cursor: 'pointer',
                    margin: new go.Margin(0, 0, 0, 0),
                    imageAlignment: go.Spot.Center,
                    imageStretch: go.GraphObject.Uniform,
                    scale: 1,
                    fromLinkable: true,
                    toLinkable: false,
                    fromLinkableDuplicates: true,
                    portId: 'core-left-side',
                    click: (e: any, obj: any) => {
                        const node = obj.part;
                        const capId = node?.data?.key;
                    },
                }),
                new go.Shape('MinusLine', {
                    width: 200,
                    height: 5,
                    margin: 0,
                    fill: null,
                    strokeWidth: 3,
                    isGeometryPositioned: true,
                    position: new go.Point(10, 10),
                }),
                $(go.Picture, {
                    source: '/icons/link-variant.svg',
                    width: 20,
                    height: 20,
                    cursor: 'pointer',
                    margin: new go.Margin(0, 0, 0, 0),
                    imageAlignment: go.Spot.Right,
                    imageStretch: go.GraphObject.Uniform,
                    scale: 1,
                    fromLinkable: true,
                    toLinkable: false,
                    fromLinkableDuplicates: true,
                    portId: 'core-right-side',
                    click: (e: any, obj: any) => {
                        const node = obj.part;
                        const capId = node?.data?.key;
                    },
                })

                // $(
                //     go.TextBlock,
                //     {
                //         margin: 1,
                //     },
                //     new go.Binding('text', 'text')
                // )
                // $(
                //     go.Shape,
                //     'Circle',
                //     {
                //         desiredSize: new go.Size(14, 14),
                //         stroke: 'black',
                //         fill: 'white',
                //         strokeWidth: 2,
                //         cursor: 'pointer',
                //         margin: new go.Margin(0, 5, 0, 5),
                //     },
                //     new go.Binding('fill', 'isActive', function (s) {
                //         return s ? 'black' : 'white';
                //     })
                // )
            )
        )
    );
}

export function setupConnectionLinkTemplate() {
    const $ = go.GraphObject.make;
    return $(go.Link, {curve: go.Link.Bezier, layerName: 'Foreground'}, $(go.Shape, {strokeWidth: 3}));
}

export function createConnectionGroupTemplate(groupName: string) {
    const $ = go.GraphObject.make;
    return $(
        go.Group,
        go.Panel.Vertical,
        {
            layout: $(go.GridLayout, {
                wrappingColumn: 1, // Ensure nodes are aligned into a single column
                alignment: go.GridLayout.Position,
                cellSize: new go.Size(1, 1),
                spacing: new go.Size(0, 1), // Adjust vertical spacing between nodes
                comparer: (a: go.Part, b: go.Part) => {
                    const aOrder = a.data.sortOrder ?? 0;
                    const bOrder = b.data.sortOrder ?? 0;
                    return aOrder - bOrder;
                },
            }),
            isSubGraphExpanded: true,
            computesBoundsAfterDrag: true,
            handlesDragDropForMembers: true,
            mouseDragEnter: (e, group: any) => {
                group.isHighlighted = true;
            },
            mouseDragLeave: (e, group: any) => {
                group.isHighlighted = false;
            },
            mouseDrop: (e, group: any) => {
                const tool = e.diagram.toolManager.draggingTool;
                const draggedParts = tool.draggedParts;
                if (draggedParts) {
                    draggedParts.each(part => {
                        if (part instanceof go.Node) {
                            part.containingGroup = group as any;
                        }
                    });
                }
                group.isHighlighted = false;
                group.layout.invalidateLayout(); // Trigger layout rearrangement

                // Sort nodeDataArray data of the group based on sortOrder
                const groupKey = group.data.key;
                // const groupNodes = me.myDiagram!.model.nodeDataArray.filter((node: any) => node.group === groupKey);

                // groupNodes.sort((a: any, b: any) => {
                //     const nodeA = me.myDiagram!.findNodeForData(a);
                //     const nodeB = me.myDiagram!.findNodeForData(b);
                //     return (nodeA?.location.y ?? 0) - (nodeB?.location.y ?? 0);
                // });

                // groupNodes.forEach((node: any, index: number) => {
                //     // node.sortOrder = index; // Update sortOrder locally
                //     e.diagram.model.setDataProperty(node, 'sortOrder', index);
                // });
            },
        },
        $(go.TextBlock, {font: 'bold 12pt sans-serif'}, new go.Binding('text', 'text')),
        $(
            go.Panel,
            go.Panel.Auto,
            $(
                go.Panel,
                go.Panel.Auto,
                $(go.Shape, 'Rectangle', {
                    fill: 'rgba(200, 200, 200, 0.33)',
                    margin: 0,
                    stroke: '#cccccc',
                    strokeWidth: 2,
                }),
                new go.Placeholder({padding: 5}) // Add padding inside the rectangle
            )
        )
    );
}
